
<template>
  <div>
    <div
      class="flex flex-wrap items-center justify-between md:px-8 px-6 sm:pb-2 sm:pt-6 "
    >
      <div class="flex mb-1">
        <div @click="returnBack" class="flex items-center">
          <feather-icon
            icon="ArrowLeftIcon"
            class="cursor-pointer mr-4"
            svg-classes="w-6 h-6"
          ></feather-icon>
          <h4>Назад</h4>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/1 sm:-1/1 w-full flex items-center justify-center">
        <vx-card>
          <br>
          <label>Konferensiya nomi</label>
          <vs-input type="email" v-model="form.name" class="w-full" />
          <br/>
          <label>Konferensiya boshlanish vaqti</label>
          <vs-input type="date" v-model="form.begin_date" class="w-full" />
          <br/>
          <label>Konferensiya tugash sanasi</label>
          <vs-input type="date" v-model="form.end_date" class="w-full" />
          <br/>
          <label>Tezis va maqolalar qabul qilinadigan oxirgi sana</label>
          <vs-input type="date" v-model="form.deadline" class="w-full" />
          <br/>
          <label>Konferensiya mavzusi</label>
          <vs-input type="text" v-model="form.subject" class="w-full" />
          <br/>
          <label>Konferensiya narxi</label>
          <vs-input type="number" v-model="form.sum" class="w-full" />
          <br/>
          <label>Batafsil malumot</label>
          <Tinymce
            name="subject"
            height="500"
            label-placeholder="Batafsil ma'lumot kiriting"
            v-model="form.description"
            class="w-full mb-6"
          />
          <br/>
          <label>Qisqacha ma'lumot</label>
          <vs-textarea type="text" v-model="form.mini_description" class="w-full" />
          <br/>
          <label>Qo'shimcha fayllar</label>
          <input type="file" id="file" ref="myFiles" class="w-full"
                 @change="uploadFile" multiple>
          <br>
          <ul class="mt-5">
            <h3>Files:</h3>
            <li v-for="(file, indexf) in form.additional_files" :key="indexf" style="display: flex; flex-direction: column">
              <div>
                <label>File nomi, masalan "Example shablon"</label>
                <vs-input v-model="file.name"></vs-input>
              </div>
              <strong><a :href="file.path" target="_blank">{{ file.path }}</a></strong>
              <a @click="deleteFile(indexf)" href="javascript:void(0)" style="color: red">O'chirish</a>
              <hr>
            </li>
          </ul>
          <br/>
          <label>Tashkilotchi</label>
          <vs-input type="text" v-model="form.organization" class="w-full" />
          <br/>
          <label>Konferensiya o'tkazilinadigan manzil</label>
          <vs-input type="text" v-model="form.address" class="w-full" />
          <br/>
          <label>Organizator telefon raqami</label>
          <vs-input type="text" v-model="form.phone" class="w-full" />
          <br/>
          <label>Organizator pochtasi</label>
          <vs-input type="text" v-model="form.email" class="w-full" />
          <br/>
          <label>To'lov uchun xisob raqami</label>
          <vs-input type="text" v-model="form.payment_account" class="w-full" />
          <br/>
          <label>Konferensiyada qatnashuv uchun talablar</label>
          <vs-textarea type="text" v-model="form.requirements" class="w-full" />
          <br>
          <vs-button v-if="id" @click="submitUpdate">Saqlash</vs-button>
          <vs-button v-else @click="submitCreate">Yaratish</vs-button>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Tinymce from "../../components/Tinymce";

export default {
  components: {
    Tinymce
  },
  data () {
    return {
      id: null,
      form: {
        name: '',
        begin_date: '',
        end_date: '',
        deadline: '',
        subject: '',
        sum: '',
        description: '',
        status: '',
        mini_description: '',
        additional_files: [],
        address: '',
        phone: '',
        email: '',
        organization: '',
        payment_account: '',
        requirements: '',
      },
      conference: {}
    }
  },
  methods: {
    deleteFile(index) {
      this.form.additional_files.splice(index, 1)
    },
    async uploadFile() {
      const file = this.$refs.myFiles.files[0]
      const form = new FormData()
      form.append('file', file)
      await axios
        .post(`https://api.conferences-list.uz/api/v1/admin/conference/upload-file`, form, {
          headers: {
            Authorization: `Bearer ${  window.localStorage.getItem('accessToken')}`
          }
        })
        .then((response) => {
          if (!this.form.additional_files) {
            this.form.additional_files = []
          }
          this.form.additional_files.push({
            path: `https://api.conferences-list.uz/storage/${response.data.path}`,
            name: 'Example File'
          })
        }).catch()
    },
    async submitCreate () {
      await axios
        .post(`https://api.conferences-list.uz/api/v1/admin/conferences/create`, this.form, {
          headers: {
            Authorization: `Bearer ${  window.localStorage.getItem('accessToken')}`
          }
        })
        .then(() => {
          this.returnBack()
        }).catch()
    },
    async submitUpdate () {
      await axios
        .post(`https://api.conferences-list.uz/api/v1/admin/conferences/update/${this.id}`, this.form, {
          headers: {
            Authorization: `Bearer ${  window.localStorage.getItem('accessToken')}`
          }
        })
        .then(() => {
          this.returnBack()
        }).catch()
    },
    returnBack () {
      this.$router.push({
        path: '/apps/conferences/'
      })
    },
    loadEditData() {
      if (this.$route.path.id) {
        this.id = this.$route.path.id
        this.loadData()
      }
    },
    async loadData () {
      await axios
        .get(`https://api.conferences-list.uz/api/v1/admin/conferences/${this.id}`, {
          headers: {
            Authorization: `Bearer ${  window.localStorage.getItem('accessToken')}`
          }
        })
        .then(response => {
          const { data } = response
          this.form = Object.assign(this.form, data)
        })
    },
    async loadCategories () {
      await axios
        .get(`https://api.conferences-list.uz/api/v1/categories/conference/${this.id}`)
        .then(response => {
          const { data } = response
        })
    }
  },
  created() {
    this.loadEditData()
  },
  async mounted () {
    if (this.$route.params && this.$route.params.id) {
      this.id = this.$route.params.id
    }
    await this.loadData()
    await this.loadCategories()
  }
}
</script>
<style scoped>
ul {
  list-style-type: disc;
}
</style>
<style lang="scss">
</style>
